export default __webpack_public_path__ + "static/media/diarymagic.057a39c5.png";